import React, { useEffect, useState } from "react";
import { Card, Row, Col, Form, Button, Badge, Spinner } from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faLayerGroup,
  faUsers,
  faFileAlt,
  faUserTie,
  faArrowLeft,
  faSave,
} from "@fortawesome/free-solid-svg-icons";

import "./plans.css";
import { CompanyService } from "Services/CompanyService";
import { toast } from "react-toastify";

const EditPlan = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState<any>({
    name: "",
    price: 0,
    billingCycle: "monthly",
    // status: "active",
    users: 0,
    exams: 0,
    proctors: 0,
    features: [],
  });


  const getPlanDetails = async () => {
    try {
      const res = await CompanyService.getPlanDetails(id!);

      if (res.status === 200) {
        const data = res.data.data;

        setFormData({
          name: data.name,
          price: data.price,
          billingCycle: data.billingCycle,
          // status: data.status,

          users: data.limits?.find((l: any) => l.key === "users")?.value || 0,
          exams: data.limits?.find((l: any) => l.key === "exams")?.value || 0,
          proctors:
            data.limits?.find((l: any) => l.key === "proctors")?.value || 0,

          features: data.features || [],
        });
      }
    } catch (error) {
      toast.error("Failed to fetch plan");
    } finally {
      setLoading(false);
    }
  };

  const generateSlug = (name: string) => {
    return name
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  };

  /* ================= UPDATE PLAN ================= */

  const updatePlan = async () => {
    try {
      const payload = {

  name: formData.name,

  slug: generateSlug(formData.name),

  price: Number(formData.price),

  currency: "INR",
  isFree: false,

  billingCycle: formData.billingCycle,

  // status: formData.status,

  features: formData.features,

  limits:[
    { key:"users", value:Number(formData.users) },
    { key:"exams", value:Number(formData.exams) },
    { key:"proctors", value:Number(formData.proctors) }
  ]

}

      const res = await CompanyService.updatePlan(id!, payload);

      if (res.status === 200) {
        toast.success("Plan updated successfully");

        navigate("/admin-dash/plan");
      }
    } catch (error) {
      toast.error("Unable to update plan");
    }
  };

  /* ================= HANDLE CHANGE ================= */

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  /* ================= FEATURE TOGGLE ================= */

  const toggleFeature = (feature: string) => {
    if (formData.features.includes(feature)) {
      setFormData({
        ...formData,
        features: formData.features.filter((f: string) => f !== feature),
      });
    } else {
      setFormData({
        ...formData,
        features: [...formData.features, feature],
      });
    }
  };

  /* ================= LOAD DATA ================= */

  useEffect(() => {
    getPlanDetails();
  }, []);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  const featureList = [
    "face_detection",
    "screen_recording",
    "live_proctoring",
    "auto_flagging",
    "id_verification",
    "report_generation",
  ];

  return (
    <div className="plans-page">
      <Card className="shadow-sm border-0 plans-card">
        <Card.Body>
          {/* HEADER */}

          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <div className="d-flex align-items-center mb-2">
                <h4 className="fw-bold mb-0 me-3">Edit Plan</h4>

                <Badge className="plan-chip">{formData.name}</Badge>
              </div>

              <small className="text-muted">
                Update subscription plan configuration
              </small>
            </div>

            <Button variant="light" onClick={() => navigate(-1)}>
              <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
              Back
            </Button>
          </div>

          {/* BASIC INFO */}

          <Card className="mb-4 modal-section-card">
            <Card.Body>
              <h6 className="section-title mb-3">
                <FontAwesomeIcon icon={faLayerGroup} className="me-2" />
                Basic Information
              </h6>

              <Row>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Plan Name</Form.Label>

                    <Form.Control
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Price (₹)</Form.Label>

                    <Form.Control
                      type="number"
                      name="price"
                      value={formData.price}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Billing</Form.Label>

                    <Form.Select
                      name="billingCycle"
                      value={formData.billingCycle}
                      onChange={handleChange}
                    >
                      <option value="monthly">Monthly</option>

                      <option value="yearly">Yearly</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Status</Form.Label>

                    <Form.Select
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value="active">ACTIVE</option>

                      <option value="inactive">INACTIVE</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* LIMITS */}

          <Card className="mb-4 modal-section-card">
            <Card.Body>
              <h6 className="section-title mb-3">Limits Configuration</h6>

              <Row>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      <FontAwesomeIcon icon={faUsers} className="me-2" />
                      Max Candidates
                    </Form.Label>

                    <Form.Control
                      type="number"
                      name="users"
                      value={formData.users}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                      Max Exams
                    </Form.Label>

                    <Form.Control
                      type="number"
                      name="exams"
                      value={formData.exams}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      <FontAwesomeIcon icon={faUserTie} className="me-2" />
                      Max Proctors
                    </Form.Label>

                    <Form.Control
                      type="number"
                      name="proctors"
                      value={formData.proctors}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* FEATURES */}

          <Card className="mb-4 modal-section-card">
            <Card.Body>
              <h6 className="section-title mb-3">AI Features Access</h6>

              <div className="feature-grid">
                {featureList.map((feature, index) => {
                  const active = formData.features.includes(feature);

                  return (
                    <Badge
                      key={index}
                      onClick={() => toggleFeature(feature)}
                      className={`feature-badge ${active ? "active-feature" : ""}`}
                    >
                      {feature.replace("_", " ")}
                    </Badge>
                  );
                })}
              </div>
            </Card.Body>
          </Card>

          {/* SAVE BUTTON */}

          <div className="text-end">
            <Button className="save-plan-btn" onClick={updatePlan}>
              <FontAwesomeIcon icon={faSave} className="me-2" />
              Update Plan
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default EditPlan;
